import React from 'react';
import PropTypes from 'prop-types';

export default function WeatherIcon({ size, color, ...rest }) {
  return (
    <svg {...rest} fill={color} width={size} height={size} viewBox="0 0 26 26">
      <path d="M13,-4.79616347e-14 C20.1765959,0.00749253713 25.9925075,5.82340405 26,13 C26,20.1797017 20.1797017,26 13,26 C5.82029825,26 1.90070182e-13,20.1797017 1.90070182e-13,13 C1.90070182e-13,5.82029825 5.82029825,-4.79616347e-14 13,-4.79616347e-14 Z M17.4546806,2.24544972 C13.104871,0.443699614 8.09802367,1.43962348 4.76882357,4.76882357 C1.43962348,8.09802367 0.443699614,13.104871 2.24544972,17.4546806 C4.04719983,21.8044901 8.29180007,24.6406413 13,24.6406413 C19.4258433,24.6331505 24.6331505,19.4258433 24.6406413,13 C24.6406413,8.29180007 21.8044901,4.04719983 17.4546806,2.24544972 Z M12.8821889,8.33739979 C15.2845987,8.33739979 17.2321366,10.2849377 17.2321366,12.6873475 C17.2321366,15.0897573 15.2845987,17.0372952 12.8821889,17.0372952 C10.4797791,17.0372952 8.5322412,15.0897573 8.5322412,12.6873475 C8.5322412,10.2849377 10.4797791,8.33739979 12.8821889,8.33739979 Z" />
    </svg>
  );
}

WeatherIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

WeatherIcon.defaultProps = {
  size: 15,
  color: '#000',
};
